export enum GapPanel {
  CustomSizeGableTop = 'custom-size-gable-panel',
  CustomSizeTop = 'custom-size-top-panel',
}
